export const getPackageVersion = () => {
  const [, tag, distance, hash] = /(.*)-(\d+)-g([a-z0-9]+)/.exec(__COMMIT_HASH__)!;

  return {
    tag,
    hash,
    distance,
  };
};
